module.exports = __webpack_public_path__ + "img/profiles_menu.f54e8cb9.svg";